import { render, staticRenderFns } from "./secondReviewList.vue?vue&type=template&id=7d53cc14&scoped=true"
import script from "./secondReviewList.vue?vue&type=script&lang=js"
export * from "./secondReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d53cc14",
  null
  
)

export default component.exports